export function getInterimComments(applicationId) {
    return axios.get(route('api.manage.applications.interim-comments', {applicationId: applicationId}))
        .then(response => response.data);
}

export function store(applicationId, data) {
    return axios.post(route('api.manage.applications.interim-comments.store', {applicationId}), data)
        .then(response => response.data);
}
